<template>
    <div class="channel-group-con">
        <h5 class="channel-group-tit">
            <p class="cgt-con f-inlineblock-top">{{ title }}</p>
            <p class="cgt-prompt f-inlineblock-top">选择绑定{{ title }}</p>
        </h5>
        
        <div class="channel-left-con f-inlineblock-top" >
            <div class="channel-item" v-for="(media,index) in showableMediaGroup" :key="index">
                <!-- 过期渠道，加上overduce类名 -->
                <div
                    class="channel-icon-block personal"
                    :class="{'overduce': media.expire}"
                    @click="selectMedia(media)"
                >
                    <!--channel-icon-border 点击选中有 描边-->
                    <div class="channel-icon" :class="{'channel-icon-border': media.isSelected}"></div>
                    <!-- 点击未过期的第一方渠道图标，加上边框及右上角出现钩子角标 -->
                    <img
                        class="channel-img"
                        :src="listMode ? media.accountHeader : media.logo"
                        alt=""
                    >
                    <i class="ico-writing ico-account-confirm" v-if="media.isSelected"></i>
                    <i
                        v-if="listMode ? media.expire : media.currentAccount.expire"
                        class="ico ico-warn"
                    ></i>
                    <div class="overdue-date-tooltip" v-if="media.expire">已过期</div>
                </div>
                <div class="channel-name" :title="media.qq | tip" style="    font-size: 12px;">{{ media.name }}</div>
                <div class="channel-subname">
                    <div
                        class="channel-subname-text"
                        style="font-size: 12px"
                        :title="media.qq | tip"
                    >
                        <template v-if="listMode">
                            <img class="select-icon" :src="media.logo" alt="">
                            {{ media.accountName }}
                        </template>
                        <template v-else>{{ media.currentAccount.accountName }}</template>
                    </div>
                    <i
                        v-if="!listMode"
                        class="ico ico-account-drap-down account-btn"
                        :class="dropAccountList === index ? 'ico-account-drap-down' : 'ico-account-drap-up'"
                        @click="showAccountList(media, index)"
                    ></i>
                    <!-- 点击显示下拉框 -->
                    <div
                        v-if="dropAccountList === index"
                        class="g-tooltip channel-selector"
                        @mouseleave="dropAccountList = -1"
                    >
                        <div class="g-tooltip-arrows-up"></div>
                        <div class="selector-content g-scrollbar">
                            <div
                                v-for="(account,index) in media.account"
                                :key="index"
                                :title="account.qq | tip"
                                @click="selectAccount(media, account)"
                            >
                                <div v-if="account.expire== 0" class="selector-item">
                                    <img class="select-icon" :src="account.accountHeader" alt="">
                                    <span class="selector-item-name">{{ account.accountName }}</span>
                                </div>
                                <div v-else class="selector-item fail-status">
                                    <img class="select-icon" :src="account.accountHeader" alt="">
                                    <i class="ico-writing ico-fail"></i>
                                    <span
                                        class="selector-item-name fail-tips-name"
                                    >{{ account.accountName }}</span>
                                    <span class="fail-tips">授权已失败</span>
                                </div>
                            </div>
                            <div class="selector-cancel" @click="dropAccountList = -1">取消</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 点击展示更多发布渠道选项【【 -->
        <div
            class="channel-item channel-more-btn js-more-btn"
            v-if="mediaGroup.length > mediaLimit"
        >
            <div class="channel-icon-block channel-btn" @click="showMore = !showMore">
                <img
                    class="channel-icon more-platform-active"
                    src="~Assets/img/pages/v4/icon-more-platform-active.png"
                    alt="更多平台"
                    v-if="showMore"
                >
                <img
                    class="channel-icon more-platform"
                    src="~Assets/img/pages/v4/icon-more-platform.png"
                    alt="更多平台"
                    v-else
                >
            </div>
            <div class="channel-name color-theme">更多平台</div>
        </div>
    </div>
</template>

<script>
import { take } from "lodash";

export default {
    name: "ChannelGroupCon",
    props: {
        defaultSelectedMediaList: {
            type: Array,
            default: function(){
                return []
            }
        },
        isPerson: {
            type: Boolean,
            default: false
        },
        title: String,
        initShowMore: {
            type: Boolean,
            default: false
        },
        mediaGroup: Array,
        listMode: {
            type: Boolean,
            default: false // 默认是 groupMode
        },
        mediaLimit: {
            // 这个是 showMore = false 时显示的数量，控制不了每行数量
            type: Number,
            default: 6
        }
    },
    data() {
        const { initShowMore: showMore } = this;
        return {
            showMore,
            dropAccountList: -1,
        };
    },
    computed: {
        showableMediaGroup() {
            return this.showMore
                ? this.mediaGroup
                : take(this.mediaGroup, this.mediaLimit);
        }
    },
    mounted(){
        setTimeout(() => {
            if(this.isPerson && !this.defaultSelectedMediaList.length){
                this.getDefaultMedia();
            }
        },2000);
    },
    methods: {
        getDefaultMedia(){
        if(this.isPerson && !this.defaultSelectedMediaList.length){
            if(localStorage.getItem('defaultMedia')){
                let selectMediaList = JSON.parse(localStorage.getItem('defaultMedia'));
                    selectMediaList.forEach((v, k) => {
                        this.showableMediaGroup.forEach((j,i) => {
                            if(v.accountId === j.accountId){
                                j.account.forEach((j2,i2) => {
                                    if(j2.id === v.accountId){
                                        this.selectMedia(j)
                                        this.selectAccount(j,j2)
                                    }
                                })
                            }
                        })
                    })
                }   
            }
        },
        showAccountList(media, index) {
            if (this.dropAccountList === -1) {
                this.dropAccountList = index;
            } else {
                this.dropAccountList = -1;
            }
        },
        selectMedia(media) {
            this.$emit("select-media", media);
        },
        selectAccount(media, account) {
            this.dropAccountList = -1;
            this.$emit("select-account", media, account);
        }
    },
    filters: {
        tip(v, label = "QQ") {
            return v > 0 ? `${label}:${v}` : "";
        }
    }
};
</script>

<style lang="scss" scoped>
@import "~Assets/sass/pages/v4/order/contribution.scss";
@import "~Assets/sass/pages/v4/order/order.scss";
@import "~Assets/sass/pages/v4/order/order_contribute.scss";
.channel-group-con {
  .channel-left-con {
    height: auto;
  }

  .channel-subname-text {
    img.select-icon {
      width: 20px;
      height: 20px;
    }
  }
}
</style>
